import { render, staticRenderFns } from "./ListResellerPaymentPage.vue?vue&type=template&id=e4f72714&"
import script from "./ListResellerPaymentPage.vue?vue&type=script&lang=js&"
export * from "./ListResellerPaymentPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports